const areMultiProps = (props) => Boolean(props.multiple || props.isMulti);
export default areMultiProps;
//# sourceMappingURL=areMultiProps.js.map